import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useContext } from '@nuxtjs/composition-api';
import CustomizeTheater from './CustomizeTheater.vue';
import MyTheaterHeader from './MyTheaterHeader.vue';
import ScreenNodes from './ScreenNodes/ScreenNodes.vue';
import FilmVoting from './FilmVoting.vue';
import TabbedSection from '~/components/Collections/TabbedSection.vue';
import { ITheaterScreenNode } from '~/types/my-theater';
import MyTheaterMetrics from './metrics/MyTheaterMetrics.vue';
import { useStore } from '~/store/composable';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyTheater',
  props: {
    screenNodes: null
  },
  setup(__props: any) {

const props = __props as {
  screenNodes?: ITheaterScreenNode[];
};



const { i18n } = useContext();

const { state } = useStore();

const hasPurchasedNodes = computed(
  () => props.screenNodes && props.screenNodes.length > 0,
);

const totalNodes = computed(() =>
  props.screenNodes ? props.screenNodes.length : 0,
);

const totalOnline = computed(() =>
  props.screenNodes ? props.screenNodes.filter((x) => x.online).length : 0,
);

const tabs = computed(() => [
  {
    tabName: i18n.t('components.myTheater.theaterNodes'),
    component: ScreenNodes,
    props: {
      screenNodes: props.screenNodes,
    },
  },
  {
    tabName: i18n.t('components.myTheater.filmVoting'),
    component: FilmVoting,
  },
]);

const dailyRewardCount = computed(
  () => state.myTheater?.theaterRewardSummary?.dailyRewardCount,
);

const totalRewardCount = computed(
  () => state.myTheater?.theaterRewardSummary?.totalRewardCount,
);

return { __sfc: true,props, i18n, state, hasPurchasedNodes, totalNodes, totalOnline, tabs, dailyRewardCount, totalRewardCount, CustomizeTheater, MyTheaterHeader, TabbedSection, MyTheaterMetrics }
}

})